"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateTemplateString = exports.validateMetrics = exports.validateCategories = exports.validateGroups = void 0;
const color_string_1 = __importDefault(require("color-string"));
const lodash_1 = __importDefault(require("lodash"));
const isValidColor = color => color_string_1.default.get(color) !== null;
const validateArray = (arr, argName) => {
  const errors = [];
  if (!Array.isArray(arr)) {
    return [`${argName} argument is not of type Array`];
  }
  if (arr.length === 0) {
    errors.push(`${argName} array is empty`);
  }
  return errors;
};
const validateProp = (obj, objectType, index, prop, expectedType) => {
  const errors = [];
  if (!(prop in obj)) {
    errors.push(`${objectType} at index ${index} does not contain '${prop}' property`);
  } else if (typeof obj[prop] !== expectedType) {
    errors.push(`${objectType} at index ${index}: Property '${prop}' must be of type '${expectedType}'`);
  }
  return errors;
};
const validateColorProp = (color, propName, objectType, index) => {
  const errors = [];
  if (typeof color !== 'string') {
    errors.push(`${objectType} at index ${index}: Property ${propName} is not of type 'string'`);
  } else if (!isValidColor(color)) {
    errors.push(`${objectType} at index ${index}: Property ${propName} is not a valid CSS color`);
  }
  return errors;
};
const validateGroups = groups => {
  const errors = [].concat(validateArray(groups, 'Groups'));
  const requiredProps = [['id', 'string'], ['label', 'string']];
  groups.forEach((group, index) => {
    if (typeof group !== 'object' || group === null) {
      errors.push(`Group at index ${index} is not of type 'object'`);
    } else {
      // Validation of required props
      requiredProps.forEach(_ref => {
        let [prop, expectedType] = _ref;
        errors.concat(validateProp(group, 'Group', index, prop, expectedType));
      });
    }
  });
  return errors;
};
exports.validateGroups = validateGroups;
const validateCategories = categories => {
  const errors = [].concat(validateArray(categories, 'Categories'));
  const requiredProps = [['id', 'string'], ['label', 'string']];
  categories.forEach((category, index) => {
    if (typeof category !== 'object' || category === null) {
      errors.push(`Category at index ${index} is not of type 'object'`);
    } else {
      // Validation of required props
      requiredProps.forEach(_ref2 => {
        let [prop, expectedType] = _ref2;
        errors.concat(validateProp(category, 'Category', index, prop, expectedType));
      });
      // Validation of optional/special props
      if ('color' in category) {
        errors.concat(validateColorProp(category.color, 'color', 'Category', index));
      }
    }
  });
  return errors;
};
exports.validateCategories = validateCategories;
const validateMetrics = (groups, categories, metrics) => {
  const errors = [].concat(validateArray(metrics));
  const allGroups = groups.map(group => group.id);
  const allCategories = categories.map(category => category.id);
  const requiredProps = [['group', 'string'], ['category', 'string'], ['metrics', 'object']];
  metrics.forEach((metric, index) => {
    // Validation of required props
    requiredProps.forEach(_ref3 => {
      let [prop, expectedType] = _ref3;
      errors.concat(validateProp(metric, 'Metric', index, prop, expectedType));
    });
    // Validate that metric.group exists in the groups array
    if ('group' in metric && !allGroups.includes(metric.group)) {
      errors.push(`Metric at index ${index}: Property 'group' is not a valid group`);
    }
    // Validate that metric.category exists in the categories array
    if ('category' in metric && !allCategories.includes(metric.category)) {
      errors.push(`Metric at index ${index}: Property 'category' is not a valid category`);
    }
    // Validate the nested metrics array
    if ('metrics' in metric) {
      const requiredMetricProps = [['id', 'string'], ['name', 'string']];
      metric.metrics.forEach(entry => {
        requiredMetricProps.forEach(_ref4 => {
          let [prop, expectedType] = _ref4;
          errors.concat(validateProp(entry, 'Metric', index, `metrics.${prop}`, expectedType));
        });
        if ('color' in entry) {
          errors.concat(validateColorProp(entry.color, 'metrics.color', 'Metric', index));
        }
      });
    }
  });
  return errors;
};
exports.validateMetrics = validateMetrics;
const validateTemplateString = (template, allowedProps) => {
  const errors = [];
  const validTextTransforms = ['capitalize', 'uppercase', 'lowercase'];
  const pattern = /(?:\*{([^*{}]*)}\*)|(?:_{([^_{}]*)}_)|(?:{([^{}]*)})|(\n)/g;
  const matches = [...template.matchAll(pattern)];
  for (let i = 0; i < matches.length; i++) {
    const match = matches[i];
    if (match[4]) {
      // matches new line
      continue;
    }
    const compoundVariable = match[1] || match[2] || match[3];
    const [variable, textTransform] = compoundVariable.split('.');
    if (!lodash_1.default.includes(allowedProps, variable)) {
      errors.push(`Template variable '${variable}' is not a valid prop`);
    }
    if (textTransform && !validTextTransforms.includes(textTransform)) {
      errors.push(`Template variable text transform '${textTransform}' is not a valid CSS text-transform`);
    }
  }
  return errors;
};
exports.validateTemplateString = validateTemplateString;